<template>
  <div class="px-2">
    <div v-if="dish.classifications.length > 0"
         class="row d-none d-md-flex">
      <div class="col-7 col-md-8 col-lg-6 col-xl-5">
        <label> {{ $t("#TR-classifications") }}:</label>
      </div>
      <div class="col-5 col-md-4 col-lg-2 col-xl-2">
        <label> {{ $t("#TR-category") }}:</label>
      </div>
    </div>

    <div v-else class="row">
      <div class="offset-3 col-6 offset-md-4 col-md-4 offset-lg-4 offset-xl-3 text-muted text-center my-3">
        {{ $t("#TR-add-new-classification") }}
      </div>
    </div>

    <transition-group name="fade2"
                      mode="out-in"
                      tag="div"
                      class="classification">
      <div v-for="(classification, index) in dish.classifications"
           :key="`classifications-${index}`"
           class="row mb-1 classification">

        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xl-5 mb-1 mb-md-0">
          <b-dropdown
            block
            size="sm"
            toggle-class="small"
            split-variant="outline-success"
            :variant="!classification.type.sifr ? 'outline-danger' : 'outline-success'"
            :text="classification.type.name"
            style="flex: auto">
            <b-dropdown-item v-for="(item, i) in classificationsTypes"
                             :key="i"
                             href="#"
                             :disabled="item.selected"
                             @click="selectClassification(item, index)">
              {{ item.name }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4 d-flex mb-3 mb-md-0">
          <b-dropdown
            block
            size="sm"
            :disabled="!classification.type.sifr"
            style="flex: auto"
            toggle-class="small"
            split-variant="outline-secondary"
            :variant="!classification.type.sifr ? 'light' : 'outline-secondary'"
            :text="classification.cat ? classification.cat.name : 'None'">
            <b-dropdown-item v-for="(cat, ind) in classification.catList"
                             :key="ind"
                             href="#"
                             @click="selectCat(cat, index)">
              {{ cat.name }}
            </b-dropdown-item>
          </b-dropdown>
          <b-button variant="danger"
                    class="ml-1 small"
                    size="sm"
                    @click="delClassifications(index)">
            <i class="mdi mdi-close"></i>
          </b-button>
        </div>

      </div>
    </transition-group>

    <div class="row mt-3">
      <div class="offset-xs-1 col-xs-10 offset-sm-3 col-sm-6 offset-md-4 col-md-4 offset-lg-3 offset-xl-2">
        <b-button block
                  variant="success"
                  :disabled="classificationsTypes.length === dish.classifications.length"
                  @click="addClassifications">
          <i class="mdi mdi-plus align-middle"></i> {{ $t("#TR-add") }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { ApiRefEditor } from '@/services/api';
  import MSG from '@/services/notify';

  export default {
    name: 'AddClassifications',

    props: {

      classificationsTypes: {
        type: Array,
        default: () => {
          return [];
        }
      },

      dish: {
        type: Object,
        require: true,
        default: () => {
          return { classifications: [] };
        }
      }
    },

    data() {
      return {
        ClassificationsCategories: []
      };
    },

    async created() {
      if (!this.dish.sifr) {
        await this.getRequireClassificationsTypes();
      }
    },

    methods: {
      addClassifications() {
        if (this.classificationsTypes.length === this.dish.classifications.length) {
          return;
        }
        this.dish.classifications.push(this.emptyClassification());
      },

      delClassifications(index) {
        this.dish.classifications.splice(index, 1);
      },

      async selectClassification(classificationType, index) {
        if (await this.isCheckedClassificationType(classificationType.sifr)) {

          return;
        }

        this.dish.classifications[index].type.selected = false;
        this.dish.classifications[index].type = classificationType;
        this.dish.classifications[index].type.selected = true;
        this.dish.classifications[index].sifr = classificationType.sifr;
        this.dish.classifications[index].value = null;
        this.dish.classifications[index].cat = null;
        this.dish.classifications[index].catList = [];

        if (!classificationType.sifr) {
          this.dish.classifications[index].type.selected = false;

          return;
        }

        const result = await ApiRefEditor.getClassificationsCategories(classificationType.sifr);

        if (result.error) {
          MSG.error(result.error, this);
        } else {
          this.dish.classifications[index].catList = result.data;
        }
      },

      selectCat(cat, index) {
        this.dish.classifications[index].cat = cat;
        this.dish.classifications[index].value = cat.sifr;
      },

      emptyClassification() {
        return {
          sifr: null,
          value: null,
          type: {
            groupingRequired: false,
            guid: null,
            sifr: null,
            name: 'Empty',
            selected: false
          },
          cat: {
            parent: null,
            guid: null,
            sifr: null,
            name: 'None'
          },
          catList: [
            {
              parent: null,
              guid: null,
              sifr: null,
              name: 'None'
            }
          ]
        };
      },

      async isCheckedClassificationType(classificationsTypeSifr) {
        const finded = this.classificationsTypes.find(
          item => item.sifr === classificationsTypeSifr);

        if (finded) {
          return !!finded.selected;
        } else {
          return false;
        }
      },

      async getRequireClassificationsTypes() {
        this.classificationsTypes.forEach(c => {
          if (c.groupingRequired) {
            this.addClassifications();
            const index = this.dish.classifications.length - 1;
            this.selectClassification(c, index);
          }
        });
      }

    }
  };
</script>

<style lang="stylus" scoped>

.b-dropdown {

}

</style>
